export const checkCallCenterOsSearchAndRescueRoute = () =>
  !!window.location.pathname.match(/callcenter|busca-e-resgate/g);
